<div class="container">
    <div class="icon-type">
        <mat-icon [svgIcon]="icon"></mat-icon>
    </div>
    <div class="content">
        <small class="set-font-size">{{ title }}</small>
        <p>{{ total }}</p>
    </div>
</div>